<template>
  <b-row>
    <b-col md="4">
      <label>Complejidad del Proyecto</label>
    </b-col>
    <b-col md="8">
      <b-form-select v-model="oferta.complejidadProyectoId" :disabled="disabled">
        <b-form-select-option
          v-for="complejidadProyecto in complejidades"
          :key="complejidadProyecto.id"
          :value="complejidadProyecto.id"
        >
          {{ complejidadProyecto.descripcion }}
        </b-form-select-option>
      </b-form-select>
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from "pinia";
import { useOfertaFormStore } from "@/stores/OfertaFormStore";
export default {
  props: {
    disabled: { type: Boolean, default: false },
  },
  computed: mapState(useOfertaFormStore, ["oferta", "complejidades"]),
};
</script>
